var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { useEffect } from 'react';
import { useDataProvider, useEvent } from 'react-admin';
import { useQuery } from '@tanstack/react-query';
export var useGetRevisions = function (resource, params, queryOptions) {
    var _a;
    if (queryOptions === void 0) { queryOptions = {}; }
    var dataProvider = useDataProvider();
    var _b = queryOptions.onError, onError = _b === void 0 ? noop : _b, _c = queryOptions.onSuccess, onSuccess = _c === void 0 ? noop : _c, _d = queryOptions.onSettled, onSettled = _d === void 0 ? noop : _d, options = __rest(queryOptions, ["onError", "onSuccess", "onSettled"]);
    var onSuccessEvent = useEvent(onSuccess);
    var onErrorEvent = useEvent(onError);
    var onSettledEvent = useEvent(onSettled);
    var result = useQuery(__assign({ queryKey: ['getRevisions', resource, params], queryFn: function () { return dataProvider.getRevisions(resource, params); }, enabled: (params === null || params === void 0 ? void 0 : params.recordId) !== undefined }, options));
    useEffect(function () {
        if (result.data === undefined ||
            result.error != null ||
            result.isFetching)
            return;
        onSuccessEvent(result.data);
    }, [onSuccessEvent, result.data, result.error, result.isFetching]);
    useEffect(function () {
        if (result.error == null || result.isFetching)
            return;
        onErrorEvent(result.error);
    }, [onErrorEvent, result.error, result.isFetching]);
    useEffect(function () {
        if (result.status === 'pending' || result.isFetching)
            return;
        onSettledEvent(result.data, result.error);
    }, [
        onSettledEvent,
        result.data,
        result.error,
        result.status,
        result.isFetching,
    ]);
    return result.data
        ? __assign(__assign({}, result), { data: (_a = result.data) === null || _a === void 0 ? void 0 : _a.data }) : result;
};
var noop = function () { return undefined; };
